import React, {
    useEffect,
    useState,
} from "react";

import API from "../../services/api";
import { Link, useNavigate } from "react-router-dom";
import {
    FaEdit,
    FaTrash,
    FaBan,
    FaCheckCircle
} from "react-icons/fa";
import { hasPermission } from "../../utils/permission";

function Users() {
    const [users, setUsers] =
        useState([]);
    const navigate = useNavigate();

    const [page, setPage] =
        useState(1);

    const [pages, setPages] =
        useState(1);

    const [search, setSearch] =
        useState("");

    useEffect(() => {
        loadUsers();
    }, [page, search]);

    const loadUsers =
        async () => {
            try {
                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/admin/users?page=${page}&search=${search}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`,
                            },
                        }
                    );

                setUsers(
                    res.data.users
                );

                setPages(
                    res.data.pages
                );
            } catch (err) {
                console.log(err);
            }
        };

    const toggleStatus =
        async (id) => {
            const token =
                localStorage.getItem(
                    "adminToken"
                );

            await API.put(
                `/admin/users/${id}/status`,
                {},
                {
                    headers: {
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

            loadUsers();
        };

    const deleteUser =
        async (id) => {
            if (
                !window.confirm(
                    "Delete user?"
                )
            )
                return;

            const token =
                localStorage.getItem(
                    "adminToken"
                );

            await API.delete(
                `/admin/users/${id}`,
                {
                    headers: {
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

            loadUsers();
        };

    return (
        <div>
            <div
                className="flex align-center justify-between 
        mb-6"
            >
                <h1
                    className="
        text-3xl
        md:text-4xl
        font-bold
        "
                >
                    Users
                </h1>

                {hasPermission("user.add") && (
                    <Link
                        to="/admin/users/add"
                        className="
                            bg-yellow-500
                            text-black
                            px-5
                            py-3
                            rounded-xl
                            font-semibold
                            "
                    >
                        + Add User
                    </Link>
                )}

            </div>

            <input
                placeholder="Search user..."
                value={search}
                onChange={(e) =>
                    setSearch(
                        e.target.value
                    )
                }
                className="
        w-full
        md:max-w-md
        p-3
        mb-6
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        "
            />

            <div
                className="
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
            >
                <div
                    className="
          overflow-x-auto
          "
                >
                    <table
                        className="
            min-w-[700px]
            w-full
            "
                    >
                        <thead>
                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >
                                <th className="p-4 text-left">
                                    Name
                                </th>

                                <th className="p-4 text-left">
                                    Phone
                                </th>

                                <th className="p-4 text-left">
                                    Email
                                </th>

                                <th className="p-4 text-left">
                                    Role
                                </th>

                                <th className="p-4 text-left">
                                    Status
                                </th>

                                <th className="p-4 text-left">
                                    Action
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {users.map(
                                (user) => (
                                    <tr
                                        key={user.id}
                                        className="
                    border-b
                    border-yellow-500/10
                    "
                                    >
                                        <td className="p-4">
                                            {user.name || "N/A"}
                                        </td>

                                        <td className="p-4">
                                            {user.phone || "N/A"}
                                        </td>

                                        <td className="p-4">
                                            {user.email || "N/A"}
                                        </td>

                                        <td className="p-4">
                                            {user.role_name || "N/A"}
                                        </td>

                                        <td className="p-4">
                                            <span
                                                className={
                                                    user.status ===
                                                        "active"
                                                        ? "text-green-500"
                                                        : "text-red-500"
                                                }
                                            >
                                                {user.status}
                                            </span>
                                        </td>

                                        <td className="p-4">
                                            <div className="flex flex-wrap gap-2">

                                                {hasPermission("user.edit") && (
                                                    <>
                                                        <Link
                                                            to={`/admin/users/edit/${user.id}`}
                                                            className="
                                                            flex
                                                            items-center
                                                            gap-2
                                                            px-3
                                                            py-2
                                                            rounded-lg
                                                            bg-blue-600
                                                            hover:bg-blue-700
                                                            text-white
                                                            text-sm
                                                            font-medium
                                                            transition-all
                                                            "
                                                        >
                                                            <FaEdit />
                                                            Edit
                                                        </Link>


                                                        <button
                                                            onClick={() => toggleStatus(user.id)}
                                                            className={`
                                                                flex
                                                                items-center
                                                                gap-2
                                                                px-3
                                                                py-2
                                                                rounded-lg
                                                                text-sm
                                                                font-medium
                                                                transition-all
                                                                ${user.status === "active"
                                                                    ? "bg-orange-500 hover:bg-orange-600 text-white"
                                                                    : "bg-green-600 hover:bg-green-700 text-white"
                                                                }
      `}
                                                        >
                                                            {user.status === "active" ? (
                                                                <>
                                                                    <FaBan />
                                                                    Block
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <FaCheckCircle />
                                                                    Unblock
                                                                </>
                                                            )}
                                                        </button>
                                                    </>
                                                )}

                                                {hasPermission("user.delete") && (
                                                    <button
                                                        onClick={() => deleteUser(user.id)}
                                                        className="
                                                        flex
                                                        items-center
                                                        gap-2
                                                        px-3
                                                        py-2
                                                        rounded-lg
                                                        bg-red-600
                                                        hover:bg-red-700
                                                        text-white
                                                        text-sm
                                                        font-medium
                                                        transition-all
                                                        "
                                                    >
                                                        <FaTrash />
                                                        Delete
                                                    </button>
                                                )}

                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}

            <div className="flex items-center gap-2 mt-6 flex-wrap">

                <button
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                    className={`
      px-4 py-2 rounded-lg
      ${page === 1
                            ? "bg-[#111] opacity-50 cursor-not-allowed"
                            : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                        }
    `}
                >
                    Back
                </button>

                {Array.from(
                    { length: pages },
                    (_, i) => i + 1
                )
                    .filter(
                        p =>
                            p === 1 ||
                            p === pages ||
                            (p >= page - 1 &&
                                p <= page + 1)
                    )
                    .map((p, index, arr) => (
                        <React.Fragment key={p}>

                            {index > 0 &&
                                arr[index - 1] !== p - 1 && (
                                    <span className="px-2">
                                        ...
                                    </span>
                                )}

                            <button
                                onClick={() => setPage(p)}
                                className={`
            px-4 py-2 rounded-lg
            ${page === p
                                        ? "bg-yellow-500 text-black"
                                        : "bg-[#111]"
                                    }
          `}
                            >
                                {p}
                            </button>

                        </React.Fragment>
                    ))}

                <button
                    disabled={page === pages}
                    onClick={() => setPage(page + 1)}
                    className={`
      px-4 py-2 rounded-lg
      ${page === pages
                            ? "bg-[#111] opacity-50 cursor-not-allowed"
                            : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                        }
    `}
                >
                    Next
                </button>

            </div>
        </div>
    );
}

export default Users;